module.exports = __webpack_public_path__ + "static/media/ic_calender.79ce379b.svg";